function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{font-size:15px;font-family:var(--font-bold);font-weight:700;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("title", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("circle", {
  cx: 24.72,
  cy: 19.62,
  r: 3.12
}), React.createElement("text", {
  className: "cls-1",
  transform: "translate(37.54 15.28) rotate(-15.01)"
}, "K"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(1, -0.04, 0.04, 1, 46.28, 12.94)"
}, "o"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.98, 0.19, -0.19, 0.98, 55.66, 12.65)"
}, "n"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(64.63 14.6) rotate(22.36)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.83, 0.55, -0.55, 0.83, 70.26, 16.75)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.69, 0.73, -0.73, 0.69, 78.39, 22.34)"
}, "k"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(0.54, 0.84, -0.84, 0.54, 83.99, 28.48)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(87.37 33.43) rotate(68.48)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(90.74 42.83) rotate(78.93)"
}), React.createElement("text", {
  className: "cls-1",
  transform: "translate(91.93 46.98) rotate(90.93)"
}, "O"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(91.39 59.22) rotate(105.01)"
}, "s"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(89.54 66.07) rotate(115.33)"
}, "s"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(66.99 89.34) rotate(164.99)"
}, "K"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-1, 0.04, -0.04, -1, 58.25, 91.68)"
}, "o"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.98, -0.19, 0.19, -0.98, 48.87, 91.97)"
}, "n"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(39.9 90.02) rotate(-157.64)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(34.27 87.87) rotate(-146.35)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(26.14 82.28) rotate(-133.25)"
}, "k"), React.createElement("text", {
  className: "cls-1",
  transform: "matrix(-0.54, -0.84, 0.84, -0.54, 20.54, 76.14)"
}, "t"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(17.16 71.19) rotate(-111.52)"
}, "a"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(13.79 61.79) rotate(-101.07)"
}), React.createElement("text", {
  className: "cls-1",
  transform: "translate(12.6 57.64) rotate(-89.07)"
}, "O"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(13.14 45.41) rotate(-74.99)"
}, "s"), React.createElement("text", {
  className: "cls-1",
  transform: "translate(14.99 38.55) rotate(-64.67)"
}, "s"), React.createElement("circle", {
  cx: 80.7,
  cy: 84.12,
  r: 3.12
})));

function SvgMail1(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 104.53 104.62"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "assets/mail1.3be578fe.svg";
export { SvgMail1 as ReactComponent };